import { render, staticRenderFns } from "./LeaveMessage.vue?vue&type=template&id=6d19e9c1&scoped=true"
import script from "./LeaveMessage.vue?vue&type=script&lang=js"
export * from "./LeaveMessage.vue?vue&type=script&lang=js"
import style0 from "./LeaveMessage.vue?vue&type=style&index=0&id=6d19e9c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d19e9c1",
  null
  
)

export default component.exports